/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect, useLayoutEffect } from 'react';

function setupGetInstanceId() {
  var instanceId = 0;
  return function getInstanceId() {
    instanceId += 1;
    return instanceId;
  };
}
var getId = setupGetInstanceId();
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
var useIsomorphicLayoutEffect = canUseDOM() ? useLayoutEffect : useEffect;
var serverHandoffCompleted = false;

/**
 * Generate a unique ID with an optional prefix prepended to it
 * @param {string} [prefix]
 * @returns {string}
 */
function useId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  var _useState = useState(function () {
      if (serverHandoffCompleted) {
        return "".concat(prefix, "-").concat(getId());
      }
      return null;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    id = _useState2[0],
    setId = _useState2[1];
  useIsomorphicLayoutEffect(function () {
    if (id === null) {
      setId("".concat(prefix, "-").concat(getId()));
    }
  }, [getId]);
  useEffect(function () {
    if (serverHandoffCompleted === false) {
      serverHandoffCompleted = true;
    }
  }, []);
  return id;
}

export { useId as default };
